import { generateProps } from 'styled-gen';
import styled from 'styled-components';

export const DotWrapper = styled.span<{bgColor: string}>`
  border-radius: 100%;
  background-color: ${({ bgColor, theme }) => bgColor ? bgColor : theme.colors.purple};

  ${generateProps};
`;
